<template>
  <div>
    <div class="ywgl-item hidden-xs">
        <div class="item-img">
          <img v-lazy="itemData.cover" alt="">
        </div>
        <div class="item-text-cont" @click="goDetail(itemData.id)">
          <div class="item-tit">{{itemData.title}}</div>
          <div class="item-cont">{{itemData.profile}}</div>
          <div class="item-tag">
            <div class="item-tag-left">
              <div class="tag-cont-css">
                <i class="el-icon-view"></i>
                <span>{{itemData.views}}</span>
              </div>
              <div class="tag-cont-css">
                <i class="el-icon-time"></i>
                <span>{{itemData.create_time}}</span>
              </div>
            </div>
            <div class="item-tag-right">
              <div v-if="isMore" @click.stop="goDetail(itemData.id)">{{ $t('view_more') }}</div>
              <div v-if="isBlck" @click.stop="back">{{ $t('back_text') }}</div>
            </div>
          </div>
        </div>
    </div>
    <div class="cell-css visible-xs" @click.stop="goDetail(itemData.id)">
      <div class="img-css">
          <el-image style="width: 100%; height:100%" :src="itemData.cover" v-lazy="itemData.cover"  fit="cover"></el-image>
      </div>
      <div class="content">
          <div class="title">{{itemData.title}}:</div>
          <div class="profile">{{itemData.profile}}</div>
          <div class="item-tag-left">
            <div class="tag-cont-css">
              <i class="el-icon-view" style="font-size: 14px;margin-right: 10px;"></i>
              <span>{{itemData.views}}</span>
            </div>
            <div class="tag-cont-css">
              <i class="el-icon-time" style="font-size: 14px;margin-right: 10px;"></i>
              <span>{{itemData.create_time}}</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      itemData:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      isMore:{
        type:Boolean,
        default: false
      },
      isBlck:{
        type:Boolean,
        default: false
      },
    },
    watch:{

    },
    data(){
      return {

      }
    },
    beforeDestroy(){

    },
    mounted() {

    },
    methods:{
      goDetail(id){
        this.$router.push({ path: "/ywglDetail", query: { id: id } });
      },
      back(){
        this.$router.push({ path: "/playguide"});
      }
    }
  }
</script>

<style scoped>
.ywgl-item{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
  .item-img{
    width: 400rem;
    height: 260rem;
    margin-right: 15rem;
  }
.item-img img{
  width: 100%;
  height: 100%;
}
  .item-text-cont{
    flex: 1;
    background-color: #fff;
    height: 260rem;
    padding:40rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  .item-tit{
    font-size: 32rem;
    color: #216F72;
  }
  .item-cont{
    font-size: 18rem;
    color: #333333;
  }
  .item-tag{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-tag-left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 15rem;
  }
  .tag-cont-css{
    margin-right: 60rem;
  }
  .item-tag-right{
    font-size: 18rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #336666;
    cursor: pointer;
  }

  @media (max-width: 992px){
    .cell-css{
      display: flex !important;

    }

    .img-css{
      width: 93rem;
      min-width: 93rem;
      height: 165rem;
    }

    .content{
      padding-top: 10px;
      margin-left: 10px;
    }

    .title{
      font-size: 15rem;
      font-family: FZLanTingHei-R-GBK;
      font-weight: 600;
      color: #216F72;
      line-height: 21rem;
      margin-bottom: 10px;
    }

    .profile{
      font-size: 14rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 28rem;
    }

    .tag-cont-css{
      display: flex;
      align-content: center;
      min-width: 50rem;
      margin-right: 10rem;
    }


  }


</style>



// WEBPACK FOOTER //
// src/components/ywglItem.vue